// src/features/dashboard/components/EmployeeCompliance/ComplianceCard.tsx

import {
  Check,
  X,
  Clock3,
  Coffee,
  ShieldCheck,
  TimerReset,
} from "lucide-react";

import {
  ComplianceCardItem,
} from "../../types/Employee/employeeCompliance.types";

interface Props {
  cards: ComplianceCardItem[];
}

const getIcon = (title: string) => {
  switch (title) {
    case "Login Compliance":
      return Clock3;

    case "Break Compliance":
      return Coffee;

    case "Hours Compliance":
      return TimerReset;

    case "Policy Compliance":
      return ShieldCheck;

    default:
      return Clock3;
  }
};

const ComplianceCard = ({ cards }: Props) => {
  return (
    <div
      className="
        grid
        grid-cols-1
        gap-4
        md:grid-cols-2
        xl:grid-cols-3
        w-full
      "
    >
     {cards.map((card) => {
  const Icon = getIcon(card.title);

 const isMet = card.status === "Met";

  return (
          <div
            key={card.id}
            className="
              min-h-[102px]
              rounded-[18px]
              border
              border-[#D0D5DD]
              bg-white
              px-[18px]
              py-[12px]
              transition-all
              duration-200
              hover:border-[#BFC8D4]
              hover:shadow-sm
            "
          >
            <div className="flex h-full items-start gap-3">
              {/* Icon */}
              <div
                className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full"
                style={{
                  backgroundColor: card.iconBgColor,
                }}
              >
                <Icon
                  size={18}
                  strokeWidth={2.4}
                  style={{
                    color: card.iconColor,
                  }}
                />
              </div>

              {/* Content */}
              <div className="min-w-0 flex-1">
                <p
                  className="
                    truncate
                    text-[13px]
                    font-semibold
                    leading-[16px]
                    text-[#101828]
                  "
                >
                  {card.title}
                </p>

          <div className="mt-1 flex items-center gap-2">
  <div
    className="flex h-6 w-6 items-center justify-center rounded-full"
    style={{
      backgroundColor: isMet ? "#15803D" : "#DC2626",
    }}
  >
    {card.status.toLowerCase() === "met" ? (
      <Check
        size={16}
        color="#FFFFFF"
        strokeWidth={3}
      />
    ) : (
      <X
        size={16}
        color="#FFFFFF"
        strokeWidth={3}
      />
    )}
  </div>

  <span
     className="text-[17px] font-bold leading-[20px]"
    style={{
        color: isMet ? "#101828" : "#DC2626",
    }}
  >
    {isMet ? "Met" : "Failed"}
  </span>
</div>

                {card.description && (
                  <p
                    className="
                    mt-1
                    text-[11px]
                    leading-[14px]
                    text-[#667085]
                    "
                  >
                    {card.description}
                  </p>
                )}

                {card.subDescription && (
                  <p
                    className="
                      truncate
                      text-[11px]
                      leading-[13px]
                      text-[#98A2B3]
                    "
                  >
                    {card.subDescription}
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ComplianceCard;